export default (pictureUrl: string | null | undefined) => {
  if (pictureUrl === null || pictureUrl === undefined) {
    return process.env.VUE_APP_DEFAULT_DP;
  }

  const urlObject = new URL(pictureUrl);

  const urlPaths = urlObject.pathname.split('/');

  const pictureName = urlPaths[urlPaths.length - 1];

  return process.env.VUE_APP_API_URL + `/image/resize/100/100/${pictureName}`;
};
